import React from 'react';
import styles from './styles.module.scss';
import {Flex, Text, Title} from '@priority-software/priority-style-react';
import {ReactComponent as SuccessSvg} from './svg/success-icon.svg';

export const SuccessComponent = (props: {title: string; subtitle: string}) => {
    const {title, subtitle} = props;

    return (
        <Flex
            componentClasses={styles.wrapper}
            direction={'column'}
            alignItems={'center'}
            justifyContent={'center'}
        >
            <div className={styles.svgIcon}>
                <SuccessSvg width={137} height={137} />
            </div>

            <Title skin={'h2'} textColor={'primary-700'}>
                {title}
            </Title>

            {subtitle && (
                <Text
                    skin={'paragraph-1'}
                    componentClasses={styles.prompt}
                    textColor={'primary-700'}
                    tag="span"
                >
                    {subtitle}
                </Text>
            )}
        </Flex>
    );
};
